import { CREATE_SESSION_MUTATION } from "@graphql"
import { useMutation } from "@apollo/client"

const useCreateSession = () => {
  const [createSession, {data, loading, error}] = useMutation(CREATE_SESSION_MUTATION)

  return {
    createSession,
    data,
    loading,
    error,
  }
}

export default useCreateSession